import {createReducer} from "typesafe-actions";
import {getOneFixtureAsync, SET_WIDGET_ID, SHOW_WIDGET} from "../actions";
import {FixtureElement} from "../../../models/api/codegen/code";

export type WidgetIdType = {
    widgetId: undefined | number
    configurationId?: string;
}

export const widgetId = createReducer<WidgetIdType>({} as WidgetIdType)
    .handleAction(getOneFixtureAsync.success, (state, action: { payload: FixtureElement }) => ({
        widgetId: action.payload.fw,
        configurationId: action.payload.wci
    }))
    .handleAction(SET_WIDGET_ID, (state, action) => action.payload);

export const showWidget = createReducer<boolean>(false)
    .handleAction(SHOW_WIDGET, (state, action) => action.payload)
